import React from 'react';
import classes from './AtomicLoader.module.css';
import clsx from 'clsx';

export interface AtomicLoaderProps {
  /**
   * Размер лоадера в пикселях
   * @default 48
   */
  size?: number;
  /**
   * Основной цвет лоадера
   * @default '#10b981'
   */
  primaryColor?: string;
  /**
   * Вторичный цвет лоадера
   * @default '#0ea5e9'
   */
  secondaryColor?: string;
  /**
   * Дополнительный CSS класс
   */
  className?: string;
}

/**
 * AtomicLoader - анимированный лоадер с эффектом "бегунка"
 */
export function AtomicLoader({
  size = 48,
  primaryColor = '#10b981',
  secondaryColor = '#0ea5e9',
  className,
}: AtomicLoaderProps) {
  const loaderStyle: React.CSSProperties = {
    width: `${size}px`,
    height: `${size}px`,
    color: primaryColor,
    '--loader-secondary-color': secondaryColor,
  } as React.CSSProperties;

  return <span className={clsx(classes.loader, className)} style={loaderStyle} />;
}
